/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { useAuditDetail } from '@/app/(client)/audits/-hooks/useAuditDetail';
import { AuditFindingsTable } from '@/components/shared/AuditFindingsTable';

const searchSchema = z.object({
  page: z.number().int().min(1).optional(),
  sort: z.string().optional(),
});

export const Route = createFileRoute(
  '/(client)/audits/(pages)/(detail)/$auditId/findings/',
)({
  validateSearch: searchSchema,
  component: AuditFindingsPage,
});

function AuditFindingsPage() {
  const { auditId } = Route.useParams();
  const search = Route.useSearch();
  const { data: audit } = useAuditDetail(auditId);

  if (!audit) return null;

  return (
    <AuditFindingsTable
      companyId={audit.companyId}
      auditId={auditId}
      auditName={audit.name}
      {...(audit.companyName != null ? { companyName: audit.companyName } : {})}
      page={search.page ?? 1}
      {...(search.sort !== undefined ? { sort: search.sort } : {})}
    />
  );
}
